export function breadthFirstTraversal<TNode>(nodes: TNode[], getChildNodes: (node: TNode) => TNode[] | null | undefined, visitNode: (node: TNode) => void): void {
    const queue: TNode[] = [...nodes];

    while (queue.length) {
        const node = queue.shift()!;
        visitNode(node)
        const childNodes = getChildNodes(node);
        if (childNodes) {
            queue.push(...childNodes);
        }
    }
}